import { render, staticRenderFns } from "./SuspiciousList.vue?vue&type=template&id=0d1c1e9d&scoped=true"
import script from "./SuspiciousList.vue?vue&type=script&lang=js"
export * from "./SuspiciousList.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousList.vue?vue&type=style&index=0&id=0d1c1e9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c1e9d",
  null
  
)

export default component.exports